import React, { useState } from "react";
import Login from "components/logins/login";

import Admin from "./components/admin/";




import { BrowserRouter, Routes, Route } from "react-router-dom";


const Rutas = () => {
  const [isLogin, setIslogin] = useState(
    localStorage.getItem("User") ? false : false
  );

  const [Isadmin, setIsadmin] = useState(
    localStorage.getItem("IsAdmin") ? true : false
  );

  return (
    <>
   
        <BrowserRouter>
          <Routes>
            {Isadmin ? (
              <>
                <Route
                  path="*"
                  element={<Admin Isadmin={Isadmin} setIsadmin={setIsadmin} />}
                />
              </>
            ) : (
              <>
                
                <Route
                  exact
                  path="/"
                  element={
                    <Login
                      setIsadmin={setIsadmin}
                      isLogin={isLogin}
                      setIslogin={setIslogin}
                    />
                  }
                />

              </>
            )}
          </Routes>
        </BrowserRouter>
  
    </>
  );
};
export default Rutas;
